import React, { FC } from 'react';
import icons from 'style';
import { StyledSVG } from 'style/styled-components/reusable.css';
import { Favorite } from 'components/Cards/Card/Card.css';

export const CardFavoriteBadge: FC<{ visible?: boolean }> = ({ visible }) => {
    if (!visible) {
        return null;
    }

    return (
        <Favorite>
            <StyledSVG svg={icons.icoFavorite} />
        </Favorite>
    );
};
